import React, { useState, useEffect } from 'react';
import SellerCardV2 from '../components/SellerCardV2';
import PickCardV2 from '../components/PickCardV2';
import './VerifiedPicksPageV2.css';

const ACCOUNT_API = 'https://563t3yrmw5d42zyd7gw6eeeun40htlid.lambda-url.us-east-1.on.aws';
const AI_CARDS_API = 'https://sqhpzxuimundhzstmjqsr6w4dq0jyyia.lambda-url.us-east-1.on.aws';
const SELLER_API = 'https://dmk7gtgi23d5kg4xkwoln7cedu0telqy.lambda-url.us-east-1.on.aws';

const VerifiedPicksPageV2 = ({ user }) => {
  const [aiCards, setAiCards] = useState([]);
  const [userSellers, setUserSellers] = useState([]);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [picks, setPicks] = useState([]);
  const [noPicksMessage, setNoPicksMessage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mySellerId, setMySellerId] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [needsSubscription, setNeedsSubscription] = useState(false);

  useEffect(() => { loadAll(); }, []);

  const getAuthHeader = () => {
    const token = localStorage.getItem('idToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const loadAll = async () => {
    setLoading(true);
    try {
      // Check if current user is a seller
      if (user) {
        try {
          const statusRes = await fetch(`${SELLER_API}/api/seller/status`, { headers: getAuthHeader() });
          const statusData = await statusRes.json();
          if (statusData.is_seller) {
            setMySellerId(statusData.seller_id);
          }
          // Load subscriptions
          const subsRes = await fetch(`${SELLER_API}/api/subscriptions`, { headers: getAuthHeader() });
          const subsData = await subsRes.json();
          setSubscriptions(Array.isArray(subsData) ? subsData.map(s => s.seller_id) : []);
        } catch (e) {}
      }

      // Load AI cards
      const aiRes = await fetch(`${AI_CARDS_API}/api/cards`);
      const aiData = await aiRes.json();
      setAiCards(aiData.map(c => ({
        id: c.card_key,
        type: 'ai',
        name: c.name,
        bio: c.description,
        verified: true,
        backtest_win_rate: c.expected_performance?.win_rate || 0,
        backtest_roi: c.expected_performance?.roi || 0,
        win_rate: c.live_performance?.win_rate || 0,
        roi: c.live_performance?.roi || 0,
        total_picks: c.live_performance?.total_picks || 0
      })));

      // Load user sellers
      const sellerRes = await fetch(`${SELLER_API}/api/sellers`);
      const sellerData = await sellerRes.json();
      setUserSellers(sellerData.map(s => ({
        id: s.seller_id,
        type: 'user',
        name: s.display_name,
        bio: s.bio || 'Verified pick seller',
        verified: true,
        win_rate: s.win_rate || 0,
        roi: s.roi || 0,
        total_picks: s.total_picks || 0
      })));
    } catch (e) {
      console.error('Load error:', e);
    }
    setLoading(false);
  };

  const selectSeller = async (seller) => {
    setSelectedSeller(seller);
    setLoading(true);
    setNoPicksMessage(null);
    setNeedsSubscription(false);
    try {
      const url = seller.type === 'ai' 
        ? `${AI_CARDS_API}/api/cards/${seller.id}/picks`
        : `${SELLER_API}/api/sellers/${seller.id}/picks`;
      const headers = seller.type === 'user' ? getAuthHeader() : {};
      const res = await fetch(url, { headers });
      const data = await res.json();
      if (data.error === 'subscription_required') {
        setNeedsSubscription(true);
        setPicks([]);
      } else if (data.message) {
        setNoPicksMessage(data.message);
        setPicks([]);
      } else {
        setPicks(Array.isArray(data) ? data : data.picks || []);
      }
    } catch (e) {
      setPicks([]);
    }
    setLoading(false);
  };

  const subscribe = async (sellerId) => {
    try {
      const res = await fetch(`${SELLER_API}/api/subscribe/${sellerId}`, {
        method: 'POST',
        headers: getAuthHeader()
      });
      const data = await res.json();
      if (data.error) {
        alert(data.error);
      } else if (data.checkout_url) {
        // Redirect to Stripe checkout
        window.location.href = data.checkout_url;
      } else {
        setSubscriptions([...subscriptions, sellerId]);
        setNeedsSubscription(false);
        selectSeller(selectedSeller);
      }
    } catch (e) {
      alert('Failed to subscribe');
    }
  };

  const addToBetSlip = async (pick) => {
    try {
      const token = localStorage.getItem('idToken');
      await fetch('https://563t3yrmw5d42zyd7gw6eeeun40htlid.lambda-url.us-east-1.on.aws/api/account/bets', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ matchup: pick.matchup, selection: pick.selection, odds: pick.odds, game_time: pick.game_time, source: 'verified_pick' })
      });
      alert('✅ Added to bet slip!');
    } catch (e) {
      alert('❌ Failed to add');
    }
  };

  if (selectedSeller) {
    return (
      <div className="verified-picks-v2">
        <button className="back-btn" onClick={() => setSelectedSeller(null)}>← Back to Sellers</button>
        <h2>{selectedSeller.name}'s Picks</h2>
        {loading ? <p className="loading">Loading...</p> : needsSubscription ? (
          <div className="subscription-prompt">
            <h3>🔒 Subscribe to View Picks</h3>
            <p>Subscribe to {selectedSeller.name} to see their picks and track record.</p>
            <p className="price">$4.99/month</p>
            {user ? (
              <button className="subscribe-btn" onClick={() => subscribe(selectedSeller.id)}>
                Subscribe Now
              </button>
            ) : (
              <p className="login-prompt">Please log in to subscribe</p>
            )}
          </div>
        ) : (
          <div className="picks-grid">
            {noPicksMessage && <p className="no-picks-message">{noPicksMessage}</p>}
            {picks.map((p, i) => <PickCardV2 key={i} pick={p} onAdd={addToBetSlip} />)}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="verified-picks-v2">
      <h2>✅ Verified Picks</h2>
      <p className="subtitle">AI strategies and verified sellers with immutable track records</p>
      {loading ? <p className="loading">Loading...</p> : (
        <>
          {/* AI Cards Section */}
          <div className="section-header">
            <h3>🤖 AI Strategies</h3>
          </div>
          <div className="sellers-grid">
            {aiCards.map(s => <SellerCardV2 key={s.id} seller={s} onSelect={selectSeller} />)}
          </div>

          {/* User Sellers Section */}
          {userSellers.length > 0 && (
            <>
              <div className="section-header">
                <h3>👤 Verified Sellers</h3>
              </div>
              <div className="sellers-grid">
                {userSellers.map(s => <SellerCardV2 key={s.id} seller={s} onSelect={selectSeller} isUserSeller isSelf={s.id === mySellerId} isSubscribed={subscriptions.includes(s.id)} />)}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default VerifiedPicksPageV2;
